import moment from "moment";
const sortByDate = (eventA, eventB) =>
  moment(`${eventA.date} ${eventA.time}`) -
  moment(`${eventB.date} ${eventB.time}`);
export default sortByDate;
